import { ChangeDetectionStrategy, Component } from '@angular/core';
import howWorkOne from '!!file-loader!./images/how-work-1.png';
import howWorkTwo from '!!file-loader!./images/how-work-2.png';
import howWorkThree from '!!file-loader!./images/how-work-3.png';
import howWorkFour from '!!file-loader!./images/how-work-4.png';
import { HelixExpressMobileApp } from '../../../../shared/constants/mobile-apps';

@Component({
  selector: 'app-how-work',
  templateUrl: './how-work.component.html',
  styleUrls: ['./how-work.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HowWorkComponent {
  HelixExpressMobileApp = HelixExpressMobileApp;

  images = {
    howWorkOne,
    howWorkTwo,
    howWorkThree,
    howWorkFour,
  };
}
